import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';


//新增
export async function addUnitGroup(params) {
    return post(oaserver+'/dict/unitGroup/addUnitGroup', params, true);
}
//编辑
export async function editUnitGroup(params) {
    return post(oaserver+'/dict/unitGroup/editUnitGroup', params, true);
}
//列表
export async function getUnitGroupList(params) {
    return post(oaserver+'/dict/unitGroup/getUnitGroupList', params, true);
}
//基准单位列表
export async function getItemList(params) {
    return post(oaserver+'/dict/item/getItemList', params, true);
}
